<template>
  <div>
    <page-header :title="$t('winrd.accounts.page_title')" />
    <page-body>
      <el-row>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-row>
            <el-col :span="4">
              <el-button type="primary" size="medium" style="margin-left:8px; border-radius: 4px; background: #327dff;" @click="addUpdateHandle()">
                {{$t('winrd.accounts.new')}}
              </el-button>
              <el-button type="primary" size="medium" style="margin-left:8px; border-radius: 4px; background: #327dff;" @click="handleSearch">
                {{$t('winrd.accounts.search')}}
              </el-button>
            </el-col>
            <el-col :span="25" sortable="false">
              <el-form-item :label="$t('winrd.accounts.platform_user')" prop="account_id" class="search-item">
                <el-cascader
                  :placeholder="$t('winrd.accounts.platform_user')"
                  v-model="searchForm.account_id"
                  :options="options"
                  :props="{emitPath: false, expandTrigger: 'hover' }"
                  filterable
                  clearable />
              </el-form-item>
              <el-form-item :label="$t('winrd.accounts.remote_account')" prop="username" class="search-item">
                <el-input v-model="searchForm.username" style="width:220px" clearable />
              </el-form-item>
              <el-form-item :label="$t('winrd.accounts.server_ip')" prop="hostname" class="search-item">
                <el-input v-model="searchForm.hostname" style="width:220px" clearable />
              </el-form-item>
              <el-form-item :label="$t('winrd.accounts.status')" prop="is_lock" class="search-item">
                <el-select v-model="searchForm.is_lock" clearable :placeholder="$t('winrd.accounts.status')" style="width:180px">
                  <el-option v-for="stat in is_lock" :key="stat.id" :label="$t(stat.name === 'winrd.accounts.normal' ? 'winrd.accounts.normal' : 'winrd.accounts.abnormal')" :value="stat.id" clearable />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-row>
        <el-table :data="dataSource" border>
          <el-table-column :label="$t('winrd.accounts.action')" width="200" align="center">
            <template slot-scope="scope">
              <div class="button-container">
                <el-button type="text" @click="updataedit(scope.row)">{{$t('winrd.accounts.edit')}}</el-button>
                <el-button type="text" @click="handleDelete(scope.$index, scope.row)">{{$t('winrd.accounts.delete')}}</el-button>
                <el-button type="text" @click="folderUp(scope.row)">{{$t('winrd.accounts.private_folder')}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="$t('winrd.accounts.id')" width="60px" />
          <el-table-column prop="account_id" :label="$t('winrd.accounts.platform_user')" width="120" align="left">
            <template slot-scope="scope">
              <span>
                {{ getUserName(scope.row.account_id) }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="remote_name" label="服务器名" width="260px" align="left" /> -->
          <el-table-column prop="remote_name" :label="$t('winrd.accounts.server_name')" align="left" width="260">
            <template slot-scope="scope">
              <span>{{ scope.row.remote_name }}</span>
              <span style="margin-left: 10px;color:#e3763e;">({{$t('winrd.accounts.online_user')}}:{{ scope.row.count || 0 }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="hostname" :label="$t('winrd.accounts.server_ip')" width="150"  align="left" />
          <el-table-column prop="port" :label="$t('winrd.accounts.port')" width="80"   align="left" />
          <el-table-column prop="username" :label="$t('winrd.accounts.remote_account')" width="120"  align="left" />
          <el-table-column prop="is_lock" align="center" :label="$t('winrd.accounts.status')" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_lock == 0">{{$t('winrd.accounts.normal')}}</el-tag>
              <el-tag v-else type="info">{{$t('winrd.accounts.abnormal')}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('winrd.accounts.created_time')" align="left" width="170">
            <template slot-scope="scope">
              {{ formatTimestamp(scope.row.created_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" :label="$t('winrd.accounts.remark')"  align="left" />
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total" />
      </el-row>
    </page-body>
    <!-- 弹窗, 新增 -->
    <add-update ref="AddUpdate" @onSubmit="getDataList" />
    <!-- 弹窗, 编辑 -->
    <edit-update ref="EditUpdate" @onSubmit="getDataList" />
    <!-- 弹窗, 文件夹 -->
    <folder-update ref="FolderUpdate" @onSubmit="getDataList" />
</div>
</template>

<script>
import { MessageBox, Message } from 'element-ui'
import { eventBus } from '@containers/WinRD/utils/eventBus' // 全局事件总线
import PageBody from '~/components/PageBody/index.vue'
import PageHeader from '~/components/PageHeader/index.vue'
import AddUpdate from './add-update'
import EditUpdate from './edit-update'
import FolderUpdate from './folder-update'

export default {
  name: 'myspace',
  components: {
    PageHeader,
    PageBody,
    AddUpdate,
    EditUpdate,
    FolderUpdate,
  },
  data () {
    return {
      pageTitle: this.$t('winrd.accounts.page_title'),
      searchForm: { },
      linkUserList: [],
      options: [],
      is_lock: [
        { id: 0, name: 'winrd.accounts.normal' },
        { id: 1, name: 'winrd.accounts.abnormal' },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
    }
  },
  created () {
    // 监听事件
    eventBus.$on('refresh-list', this.fetchData)
    this.linkUser()
  },
  mounted () {
    this.fetchData()
  },
  beforeDestroy () {
    // 移除事件监听
    eventBus.$off('refresh-list', this.fetchData)
  },
  methods: {
    // 列表获取
    async fetchData () {
      try {
        if (!this.pagination) {
          console.error('this.pagination is not defined')
          return
        }

        const dataRaw = {
          account_id: this.searchForm.account_id,
          username: this.searchForm.username,
          hostname: this.searchForm.hostname,
          is_lock: this.searchForm.is_lock,
          page: this.pagination.currentPage,
          per_page: this.pagination.pageSize,
        }

        const response = await this.$axios.get('/api/sa/rdbackend/list_users', {
          params: dataRaw,
        })

        const overViewListData = response.data
        this.dataSource = overViewListData.users || []
        this.pagination.total = overViewListData.count || 0
        this.pagination.currentPage = overViewListData.page || 1

        // 获取每个服务器的请求接口数量
        await this.fetchApiCounts()
      } catch (error) {
        console.error('There was an error!', error)
      }
    },
    // 获取每个服务器的请求接口数量
    async fetchApiCounts () {
      try {
        const response = await this.$axios.get('/api/sa/rdbackend/connections')
        const res = response.data.data
        for (let i = 0; i < this.dataSource.length; i++) {
          const item = this.dataSource[i]
          for (let j = 0; j < res.length; j++) {
            if (item.remote_name === res[j].name) {
              this.$set(item, 'count', res[j].count)
            }
          }
        }
      } catch (error) {
        console.error('There was an error fetching API counts!', error)
      }
    },

    // 获取所属用户
    async linkUser () {
      try {
        // 发送 GET 请求获取用户数据
        const response = await this.$axios.get('/api/sa/rdbackend/get_users')

        // 确保 response.data 是一个数组
        this.linkUserList = Array.isArray(response.data.data) ? response.data.data : []

        // 处理 options 数据
        this.options = this.linkUserList.map(domain => ({
          value: domain.domain_id, // 平台 ID
          label: domain.project_domain, // 平台名称
          children: domain.user ? domain.user.map(user => ({
            value: user.id, // 用户 ID
            label: user.displayname || user.name, // 用户名称
          })) : [], // 如果没有用户，则 children 为空数组
        }))
      } catch (error) {
        console.error('There was an error!', error)
      }
    },
    getUserName (accountId) {
      const user = this.findUserById(accountId)
      return user ? user.label : ' '
    },
    findUserById (accountId) {
      for (const domain of this.options) {
        for (const user of domain.children) {
          if (user.value === accountId) {
            return user
          }
        }
      }
      return null
    },

    // 查询
    handleSearch () {
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 分页
    handleSizeChange (val) {
      // 改变每页显示的条数
      this.pagination.pageSize = val
      this.fetchData(this.pagination.currentPage, this.pagination.pageSize)
    },

    handleCurrentChange (val) {
      // 改变默认的页数
      this.pagination.currentPage = val
      this.fetchData(this.pagination.currentPage, this.pagination.pageSize)
    },

    // 新增
    addUpdateHandle (row) {
      this.$refs.AddUpdate.init({ ...row }, this.appTypeList)
    },

    // 修改
    updataedit (row) {
      this.$refs.EditUpdate.init({ ...row }, this.appTypeList)
    },

    // 编辑文件夹
    folderUp (row) {
      this.$refs.FolderUpdate.init({ ...row }, this.appTypeList)
    },

    // 删除
    handleDelete (idx, row) {
      MessageBox(this.$t('winrd.accounts.delete_confirm', { username: row.username }), this.$t('winrd.accounts.tip'), {
        confirmButtonText: this.$t('winrd.accounts.confirm'),
        cancelButtonText: this.$t('winrd.accounts.cancel'),
        type: 'warning',
      }).then(() => {
        const params = {
          host_id: row.host_id,
          username: row.username,
          action: 'delete',
        }

        this.$axios.post('/api/sa/rdbackend/delete_user', params, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(resp => {
          this.fetchData() // 更新用户列表
          if (resp.data.code === 200) {
            const message = resp.data.message
            Message({
              message,
              type: 'success',
            })
          } else {
            Message({
              message: this.$t('winrd.accounts.delete_failed') + ': ' + resp.data.errmsg,
              type: 'error',
            })
          }
        }).catch(error => {
          console.error('Error deleting user:', error)
          Message({
            message: this.$t('winrd.accounts.delete_failed') + ': ' + error.message,
            type: 'error',
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('winrd.accounts.cancel_delete'),
        })
      })
    },

    // 转换时间戳
    formatTimestamp (timestamp) {
      if (timestamp) {
        const date = new Date(timestamp * 1000) // 将秒转换为毫秒
        return date.toLocaleString() // 返回本地化的日期和时间字符串
      }
      return ''
    },
  },
}
</script>

<style scoped>
body,html{
  min-width: 1280px;
}
.el-table thead{
  color: #333 !important;
  font-weight: bold !important;
}
.el-button{
  float: left;
  margin-right: 10px;
}
.el-tag {
  margin-right: 10px;
  margin-bottom: 5px;
}
.el-tag:last-child {
  margin-right: 0;
  margin-bottom: 0;
}
.el-tag{
  border: 0;
  color: #606266;
  background: rgba(0, 0, 0, 0);
}
.el-tag.el-tag--info{
  border: 0;
  color: #606266;
  background: rgba(0, 0, 0, 0);
}
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.button-container .el-button {
  margin: 0 5px; /* 可选：为按钮添加一些间距 */
}
.el-table th.el-table__cell>.cell{
  color: #333 !important;
}
</style>
